module.exports = __webpack_public_path__ + "static/img/uncle-cake-icon.3997e6a1.png";